import { BadgeVariant } from 'uiComponents/badge'
import { LucideIconName } from 'utils/lucideIcon'
import { PricingPlanAction, PricingPlanStatus } from '../types'
import { t } from 'translations'

interface PricingPlanStatusConfig {
    showDate: boolean
    showMemberCount: boolean
    badgeVariant?: BadgeVariant
    badgeLabel: string
    availableActions: PricingPlanAction[]
}

export const getPricingPlanStatusConfig = (): Record<PricingPlanStatus, PricingPlanStatusConfig> => ({
    draft: {
        showDate: false,
        showMemberCount: false,
        badgeVariant: 'info',
        badgeLabel: t('products.pricing.pricingPlans.status.draft'),
        availableActions: ['activate', 'edit', 'remove'],
    },
    active: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'success',
        badgeLabel: t('products.pricing.pricingPlans.status.active'),
        availableActions: [],
    },
    open: {
        showDate: true,
        showMemberCount: true,
        badgeLabel: '',
        availableActions: ['migrate', 'discontinue', 'remove'],
    },
    migrating: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'warning',
        badgeLabel: t('products.pricing.pricingPlans.status.migrating'),
        availableActions: ['stop_migrating'],
    },
    discontinued: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'neutral',
        badgeLabel: t('products.pricing.pricingPlans.status.discontinuing'),
        availableActions: ['stop_discontinuing'],
    },
    closed: {
        showDate: true,
        showMemberCount: false,
        badgeVariant: 'neutral',
        badgeLabel: '',
        availableActions: [],
    },
    conditionally_migrating: {
        showDate: false,
        showMemberCount: true,
        badgeVariant: 'warning',
        badgeLabel: '',
        availableActions: [],
    },
})

export const getKebabMenuLabels = (): Record<PricingPlanAction, { label: string; icon: LucideIconName }> => ({
    activate: { label: t('products.pricing.pricingPlans.actions.activate'), icon: 'CircleCheck' },
    edit: { label: t('products.pricing.pricingPlans.actions.edit'), icon: 'Pencil' },
    remove: { label: t('products.pricing.pricingPlans.actions.remove'), icon: 'CircleX' },
    discontinue: { label: t('products.pricing.pricingPlans.actions.discontinue'), icon: 'CircleX' },
    migrate: { label: t('products.pricing.pricingPlans.actions.migrate'), icon: 'RefreshCcwDot' },
    stop_migrating: { label: t('products.pricing.pricingPlans.actions.stopMigrating'), icon: 'CircleX' },
    stop_discontinuing: { label: t('products.pricing.pricingPlans.actions.stopDiscontinuing'), icon: 'CircleX' },
})
